var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["c-contact-entity", { "space--bottom": _vm.space }] },
    [
      _vm.image
        ? [
            _c("div", { staticClass: "c-contact-entity__image" }, [
              _c("img", {
                attrs: {
                  src: _vm.image,
                  height: "45",
                  width: "45",
                  alt: "",
                  "aria-hidden": "true"
                }
              })
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "c-contact-entity__content" },
        [
          _c("p", { staticClass: "c-contact-entity__heading" }, [
            _vm._v(_vm._s(_vm.name))
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "c-contact-entity__subheading" }, [
            _vm._v(_vm._s(_vm.worktitle))
          ]),
          _vm._v(" "),
          _vm.text
            ? [
                _c("div", { staticClass: "c-contact-entity__text" }, [
                  _vm._v("\n\t\t\t\t" + _vm._s(_vm.text) + "\n\t\t\t")
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.address
            ? [
                _c("p", { staticClass: "c-contact-entity__address" }, [
                  _vm._v(_vm._s(_vm.address))
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.phone
            ? [
                _c("p", { staticClass: "c-contact-entity__link" }, [
                  _c(
                    "a",
                    {
                      staticClass: "c-contact-entity__link-a",
                      attrs: { href: "tel:" + _vm.phone }
                    },
                    [_vm._v(_vm._s(_vm.phone))]
                  )
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.email
            ? [
                _c("p", { staticClass: "c-contact-entity__link" }, [
                  _c(
                    "a",
                    {
                      staticClass: "c-contact-entity__link-a",
                      attrs: { href: "mailto:" + _vm.email }
                    },
                    [_vm._v(_vm._s(_vm.email))]
                  )
                ])
              ]
            : _vm._e()
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }